export default "https://cdn-static-staging.gokick.com/assets/ec0de4ab37568b9a2e84c5fbf7dadc9a5c7c6fae/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";